import React from "react";
import {
  Select,
  SelectProps,
  SpaceBetween,
} from "@amzn/awsui-components-react";

interface UsecaseDestinationSelectsProps {
  selectedUsecase: SelectProps.Option | null;
  setSelectedUsecase: (option: SelectProps.Option | null) => void;
  selectedDestination: SelectProps.Option;
  setSelectedDestination: (option: SelectProps.Option) => void;
  validUsecases: SelectProps.Option[];
  destinationOptions: SelectProps.Option[];
  dropdownDisabled: boolean;
  productOptions?: SelectProps.Option[];
  selectedProduct?: SelectProps.Option | null;
  setSelectedProduct?: (option: SelectProps.Option | null) => void;
}

export const UsecaseDestinationSelects: React.FC<
  UsecaseDestinationSelectsProps
> = ({
  selectedUsecase,
  setSelectedUsecase,
  selectedDestination,
  setSelectedDestination,
  validUsecases,
  destinationOptions,
  dropdownDisabled,
  productOptions,
  selectedProduct,
  setSelectedProduct,
}) => {
  const handleSelectChange = React.useCallback(
    (setter: (option: SelectProps.Option) => void) =>
      ({ detail }: { detail: { selectedOption: SelectProps.Option } }) => {
        setter(detail.selectedOption);
      },
    []
  );

  return (
    <SpaceBetween size="m" direction="horizontal">
      <Select
        selectedOption={selectedUsecase}
        onChange={handleSelectChange(setSelectedUsecase)}
        options={validUsecases}
        disabled={dropdownDisabled}
        placeholder="Select usecase"
      />
      {productOptions && productOptions.length > 0 && setSelectedProduct && (
        <Select
          selectedOption={selectedProduct || null}
          onChange={({ detail }) => setSelectedProduct(detail.selectedOption)}
          options={productOptions}
          placeholder="Select product"
        />
      )}
      <Select
        selectedOption={selectedDestination}
        onChange={handleSelectChange(setSelectedDestination)}
        options={destinationOptions}
        disabled={destinationOptions.length <= 1}
      />
    </SpaceBetween>
  );
};
